import { useState } from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Logo from '../StoraEnsoComponents/Logo';
import {
  MenuWrapper,
  MobileMenuWrapper,
  MenuToggleWrapper,
  MenuItems,
  MenuIcon,
  CloseIcon
} from './menu';
import { HOME, USER_PROFILE } from "../../Routes";
import { ReactComponent as UserSvg } from '../../assets/icons/fa-circle-user.svg';
import { ReactComponent as LogoutSvg } from '../../assets/icons/fa-arrow-right-from-bracket.svg';

const UserIcon = styled(UserSvg)`
  width: 18px;
  height: auto;
  cursor: pointer;

  fill: ${({theme}) => theme.colors.text_dark};
`;

const LogoutIcon = styled(LogoutSvg)`
  width: 18px;
  height: auto;
  fill: ${({theme}) => theme.colors.text_dark};
  cursor: pointer;

  &:hover {
    fill: ${({theme}) => theme.colors.link_hover};
  }
`;

const ProfileLink = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    color: ${({theme}) => theme.colors.link_hover};

    ${UserIcon} {
      fill: ${({theme}) => theme.colors.link_hover};
    }
  }

  span {
    display: none;
  }

  @media screen and (min-width: 576px) {
    ${UserIcon} {
      margin-right: 8px;
    }

    span {
      display: block;
    }
  }
`;

const HeaderWrapper = styled.header`
  position: relative;
  height: 80px;
  flex: 0 1 auto;
  z-index: 1001;
  width: 100%;
  padding-bottom: 80px;
`;

const Container = styled.div`
  position: fixed;
  height: 80px;
  border-bottom: 2px solid ${({theme}) => theme.colors.bg_gray_dark};
  z-index: 1000;
  max-width: 1920px;
  width: 100%;
  background-color: ${({theme}) => theme.colors.white};
  padding: 0 15px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 100%;
  max-width: 1170px;
  position: relative;
`;

const LogoWrapper = styled.div`
  height: 100%;
  width: 80px;
  display: block;

  ${Logo} {
    display: block;
    width: 100%;
    height: 100%;
    max-height: 70px;
    object-fit: contain;
    object-position: left;
  }
`;

const MainNav = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Divider = styled.span`
  margin: 0 16px;
`;

const ActionLink = styled.span`
  cursor: pointer;
`;

const RightNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
  /* padding-right: 20px; */
`;

const ProfileActions = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-end;

  a,
  ${ActionLink} {
      color: ${({theme}) => theme.colors.heading_dark};
      text-decoration: none;
  }

  a:hover,
  ${ActionLink}:hover {
      color: ${({theme}) => theme.colors.link};
      text-decoration: none;
  }
`;

function Header() {
  const [isMobileOpen, setMobileOpen] = useState(false);
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogout = () => {
    instance.logoutRedirect();
  }

  const closeMobileMenu = () =>  setMobileOpen(false);

  return (
    <HeaderWrapper>
      <Container>
        <Content>

          <MainNav>
            <LogoWrapper>
              <Link to={HOME}>
                <Logo />
              </Link>
            </LogoWrapper>
            <MenuWrapper>
              <MenuItems onLinkClick={closeMobileMenu} />
            </MenuWrapper>
          </MainNav>

          <RightNav>
            <MenuToggleWrapper>
              {
                isMobileOpen ?
                  <CloseIcon onClick={() => setMobileOpen(false)} />
                    :
                  <MenuIcon onClick={() => setMobileOpen(true)} />
              }
              <Divider>|</Divider>
            </MenuToggleWrapper>
            {
              isAuthenticated && (
                <>
                  <ProfileActions>
                    <ProfileLink to={USER_PROFILE} onClick={closeMobileMenu}>
                      <UserIcon id="User_Profile" />
                      <span>{accounts[0].name}</span>
                    </ProfileLink>
                    <Divider>|</Divider>
                  <LogoutIcon id="Logout" onClick={handleLogout} />
                </ProfileActions>
                </>
              )
            }
          </RightNav>

          { isMobileOpen && (
            <MobileMenuWrapper>
              <div>
                <MenuItems onLinkClick={closeMobileMenu} />
              </div>
            </MobileMenuWrapper>
          )}

        </Content>
      </Container>
    </HeaderWrapper>
  );
}

export default Header;